import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowDown",
  "use": "ArrowDown-usage",
  "viewBox": "0 0 36 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 18\" id=\"ArrowDown\"><path d=\"M3.7 0L18 10.8 32.3 0 36 4.3 18 18 0 4.3 3.7 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol